import { Icon } from "@plura/client/components";
import { cn } from "@plura/shared/utils";
import Link from "next/link";

import { LandingIcon } from "../../../atoms/LandingIcon";
import { MegaMenuProps } from "../types";

const MegaMenu = ({ lists, callout }: MegaMenuProps) => {
  return (
    <div
      className={cn(
        "mb-10 flex w-full flex-row flex-wrap justify-center gap-5 p-5 text-t-light",
        "max-lg:mb-0 max-lg:h-auto max-lg:min-h-0 max-lg:flex-col max-lg:flex-nowrap max-lg:items-start max-lg:justify-start max-lg:gap-0 max-lg:p-0 max-lg:px-5 max-lg:pb-10 max-lg:pt-[calc(env(safe-area-inset-top,0px)+1.5rem)] max-lg:text-left",
      )}
    >
      {lists.map((list, listIndex) => (
        <nav
          className={cn(
            "flex min-w-[300px] max-w-[340px] flex-col gap-5 border-r border-white/10 px-5",
            "max-lg:min-w-0 max-lg:max-w-none max-lg:w-full max-lg:border-0 max-lg:px-0 max-lg:pb-8",
            listIndex > 0 && "max-lg:border-t max-lg:border-white/10 max-lg:pt-8",
          )}
          key={list.title}
        >
          <div className="flex flex-row items-center gap-2.5 text-t-tertiary max-lg:text-t-secondary">
            <LandingIcon faClass={list.icon} className="!size-4 shrink-0 fill-current max-lg:!size-[18px]" />
            <h6 className="text-sm font-medium tracking-wide uppercase max-lg:text-[13px]">
              {list.title}
            </h6>
          </div>
          <div className="flex flex-col gap-4 max-lg:gap-5">
            {list.items.map((item) => (
              <Link href={item.link} target={item.external ? "_blank" : undefined} key={item.title}>
                <div className="flex translate-x-0 flex-col items-start text-left transition-all duration-150 ease-in-out max-lg:gap-0.5 hover:max-lg:translate-x-0 lg:hover:translate-x-1.5">
                  <h6 className="text-base font-medium text-t-light max-lg:text-[17px]">{item.title}</h6>
                  <span className="text-xs leading-snug text-t-secondary max-lg:text-[13px]">{item.description}</span>
                </div>
              </Link>
            ))}
          </div>
        </nav>
      ))}
      <div
        className={cn(
          "flex min-w-[300px] max-w-[340px] flex-col gap-5 px-5",
          "max-lg:min-w-0 max-lg:max-w-none max-lg:w-full max-lg:border-t max-lg:border-white/10 max-lg:px-0 max-lg:pt-8",
        )}
      >
        <div className="flex flex-row items-center gap-2.5 text-t-tertiary max-lg:text-t-secondary">
          <LandingIcon faClass={callout.icon} className="!size-4 shrink-0 fill-current max-lg:!size-[18px]" />
          <h6 className="text-sm font-medium tracking-wide uppercase max-lg:text-[13px]">{callout.title}</h6>
        </div>
        <div className="flex w-full flex-col gap-5 max-lg:items-start">
          <Link
            href={callout.link}
            className="group flex w-full max-w-[340px] flex-col items-start text-left text-t-light transition-all duration-150 ease-in-out hover:scale-[1.02] max-lg:max-w-[min(100%,320px)]"
          >
            <img
              src={callout.image}
              alt={callout.title}
              className="mb-5 w-full max-w-[300px] rounded-[10px] object-cover max-lg:max-w-full"
            />
            <h6 className="text-sm font-medium max-lg:text-base">{callout.caption}</h6>
            <strong className="mt-0 flex items-center gap-2 text-sm font-semibold transition-colors duration-150 group-hover:text-primary-01 max-lg:text-[15px]">
              <span className="underline">{callout.linkText}</span>
              <Icon name="arrow" className="!size-3.5 shrink-0 fill-current max-lg:!size-4" aria-hidden />
            </strong>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default MegaMenu;
